import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../../actions/Helper_action";
import { Search } from "react-feather";
import {
  Get_List_Sell_Contracts,
  Sell_Delete_Status,
  View_Sell_Contract,
} from "../../../actions_agent/Invoice_action";
import { Button, Drawer, Input, Modal, Switch, Tooltip } from "antd";
import Swal from "sweetalert2";
import { isMobile } from "react-device-detect";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
import CustomDataTable from "../../../components/HOC/CustomDataTable";
import { FilterComponent } from "../../../components/HOC/FilterComponent";
import EditContractSell from "./EditContractSell";
const ListSellContract = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.AuthReducer.user);
  const [hideDirector, setHideDirector] = useState(false);
  useEffect(() => {
    if (user && user.v_contract !== false) {
      setHideDirector(false);
    } else {
      setHideDirector(true);
    }
    dispatch(Get_List_Sell_Contracts());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const sell_contracts = useSelector(
    (state) => state.Invoice_Reducer.sell_contracts
  );
  const [search, setsearch] = useState("");
  const [select_sell, setselect_sell] = useState("");
  const [visible, setvisible] = useState(false);
  const [showModal_, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal_);
  };
  const initialColumns = React.useMemo(() => {
    return [
      {
        name: dispatch(change_Lang("id")),
        selector: "id",
        center: true,
        compact: true,
        width: "100px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("first_rule_place")),
        selector: "place",
        center: true,
        compact: true,
        width: "120px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Property Detail")),
        selector: "property_detail",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("First Party (Seller)")),
        selector: "firstName",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Second Party (Buyer)")),
        selector: "secondName",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("pr_price")),
        selector: "lastPrice",
        center: true,
        compact: true,
        className: "fk",
        width: "100px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("date")),
        selector: "date",
        center: true,
        compact: true,
        width: "120px",
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Action")),
        selector: "action",
        center: true,
        compact: true,
        omit: hideDirector,
        width: "130px",
        visibility: true,
      },
    ];
  }, [hideDirector]);
  const [columns, setColumns] = useState(initialColumns);
  const handleColumnToggle = (columnKey) => {
    setColumns((prevColumns) =>
      prevColumns.map((column) =>
        column.selector === columnKey
          ? { ...column, visibility: !column.visibility }
          : column
      )
    );
  };
  const showDrawer = () => {
    setvisible(true);
  };
  const onClose = () => {
    setvisible(false);
  };
  const handleChange_Property = (value) => {
    setselect_sell(value);
  };
  const Sell_getPrint = () => {
    window.setTimeout("window.print()", 2000);
  };
  const onDeleteSell_Contract = (id, status) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      text: dispatch(change_Lang("You won't be able to delete this!")),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Sell_Delete_Status(id, status));
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const datas = sell_contracts
    .filter((data) => {
      return FilterComponent({
        main_state: search,
        secondary_state: select_sell,
        element: data,
        change_able:
          data.secondname &&
          data.secondname.toLowerCase().startsWith(search.toLowerCase()),
      });
    })
    .map((el, i) => {
      return {
        id: el.InvoiceNO,
        branchId: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.branchId.name}
          </span>
        ),
        Agent_name: (
          <span
            className={`${lang === "en" ? "" : "fk"}`}
          >{`${el.agentId.fname} ${el.agentId.lname}`}</span>
        ),
        Area: <span className={`${lang === "en" ? "" : "fk"}`}>{el.Area}</span>,
        place: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {lang === "en"
              ? el.available_id && el.available_id.Place_en
              : lang === "arb"
              ? el.available_id && el.available_id.Place_ar
              : el.available_id && el.available_id.Place_ku}
          </span>
        ),
        firstName: (
          <div
            className={`${lang === "en" ? "text-center" : "text-center fk"}`}
          >
            {el.firstname}
            <br />
            {el.phone1}
          </div>
        ),
        secondName: (
          <div
            className={`${lang === "en" ? "text-center" : "text-center fk"}`}
          >
            {el.secondname} <br />
            {el.phone1}
          </div>
        ),
        lastPrice: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.lastPrice}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix="$"
          />
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
        property_detail: (
          <>
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id &&
                dispatch(change_Lang(el.available_id.Property))}
            </span>
            &nbsp;-&nbsp;
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id && el.available_id.Property !== "Apartment"
                ? el.available_id && el.available_id.NOoFProperty
                : `${el.available_id && el.available_id.block}-${
                    el.available_id && el.available_id.flour
                  }-${el.available_id && el.available_id.NOoFProperty}`}
            </span>
          </>
        ),
        action: (
          <>
            <Tooltip title="View">
              {/* <Link to={`/view_contract_sell/${el._id}/${el.InvoiceNO}`}> */}
              <Button
                style={{ background: "#efefed", color: "#4064d7" }}
                shape="circle"
                onClick={() => {
                  dispatch(View_Sell_Contract(el._id, el.InvoiceNO));
                  showDrawer();
                }}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
              {/* </Link> */}
            </Tooltip>
            &nbsp;
            <Tooltip title="Print">
              <Link to={`/print_Sell_View/${el._id}/${el.InvoiceNO}`}>
                <Button
                  style={{ background: "#efefed", color: "#4064d7" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(View_Sell_Contract(el._id, el.InvoiceNO));
                    Sell_getPrint();
                  }}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="fas fa-print text-center mt-1"
                    ></i>
                  }
                />
              </Link>
            </Tooltip>
            &nbsp;
            {user.d_contract !== false ? (
              <Tooltip title="Delete">
                <Button
                  style={{ background: "#efefed", color: "#4064d7" }}
                  shape="circle"
                  onClick={() => onDeleteSell_Contract(el._id, "delete")}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="fas fa-ban text-center mt-1"
                    ></i>
                  }
                />
              </Tooltip>
            ) : (
              ""
            )}
          </>
        ),
      };
    });
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Sell Contracts"))}
          parent={dispatch(change_Lang("Contract List"))}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <div className={isMobile ? "" : "card"}>
                <div className="row ">
                  <div
                    className={
                      isMobile
                        ? "col-md-4 d-flex justify-content-center"
                        : "col-md-3 card-header d-flex justify-content-start"
                    }
                  >
                    <PropertyesList
                      onChangeProperty={handleChange_Property}
                      valueOption={select_sell}
                      size="middle"
                      style={{
                        fontSize: "16px",
                        borderBottomColor: "#4064d7",
                      }}
                    />
                  </div>

                  <div
                    className={isMobile ? "col-md-6" : "col-md-6 card-header"}
                  >
                    <div className=" text-center mt-2">
                      <h4 style={{ fontWeight: "bold", color: "#4064d7" }}>
                        {dispatch(change_Lang("Sell Contracts"))}
                      </h4>
                    </div>
                  </div>
                  <div
                    className={
                      isMobile
                        ? "col-md-3 d-flex justify-content-center form-inline"
                        : "col-md-3 d-flex justify-content-start form-inline"
                    }
                  >
                    <Input
                      type="text"
                      name="search"
                      value={search}
                      onChange={(e) => setsearch(e.target.value)}
                      size="middle"
                      placeholder={dispatch(change_Lang("Search"))}
                      autoComplete="off"
                      style={{ width: "180px" }}
                      prefix={<Search color="lightgray" />}
                    />
                    &nbsp;&nbsp;
                    <span className="">
                      <button
                        onClick={toggleModal}
                        className="btn m-auto btn-sm p-1 exp_btn "
                      >
                        <i className="fa-solid fa-bars"></i>
                      </button>
                    </span>
                  </div>
                </div>
                <div className="row table-responsive">
                  <CustomDataTable
                    columns={columns.filter((column) => column.visibility)}
                    data={datas}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Drawer onClose={onClose} open={visible} width="950px">
          <EditContractSell onClose={onClose} />
        </Drawer>
        <Modal
          title="Select Columns"
          open={showModal_}
          onCancel={toggleModal}
          width={430}
          footer={[
            <Button key="close" onClick={toggleModal}>
              Close
            </Button>,
          ]}
        >
          {columns.map((column) => (
            <div
              className="row d-flex justify-content-center"
              key={column.selector}
              style={{ marginBottom: 16, textAlign: "justify" }}
            >
              <span
                className="col-5 fk"
                style={{ marginLeft: 8, fontSize: "15px" }}
              >
                {column.name}
              </span>
              <Switch
                checked={column.visibility}
                style={{
                  background: column.visibility ? "#5172dd" : "#babbba",
                }}
                className="col-1"
                onChange={() => handleColumnToggle(column.selector)}
              />
            </div>
          ))}
        </Modal>
      </Fragment>
    </>
  );
};

export default ListSellContract;
